module.exports = __webpack_public_path__ + "media/images/caution-sign-55a55275.svg";